import { notifications } from '@mantine/notifications';
import { IconAlertTriangle, IconCheck } from '@tabler/icons-react';
import { errorMessage } from '@/api/client';

export function notifySuccess(message: string, title?: string): void {
  notifications.show({ color: 'teal', icon: <IconCheck size={18} />, title, message, autoClose: 3500 });
}

export function notifyError(error: unknown, title = 'That did not work'): void {
  notifications.show({ color: 'red', icon: <IconAlertTriangle size={18} />, title, message: errorMessage(error), autoClose: 6000 });
}
